import script from "./ExpiredCreditQuery.vue?vue&type=script&lang=js"
export * from "./ExpiredCreditQuery.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__